// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ao_compute.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'ao_computePixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform highp sampler2D depthSampler;
uniform sampler2D noiseSampler;
uniform vec2 noiseScale;
uniform vec3 sampleKernel[sampleKernelSize];
uniform mat4 invertedProjectionMatrix;
uniform mat4 projectionMatrix;
uniform float radius;
uniform vec2 noiseUvOffset;
uniform vec2 inverseDepthDimensions;
const float ssaoDepthBias = 0.01;
#define LINEAR_DEPTH
vec3 viewSpacePositionFromDepth(float z, float u, float v)
{
#ifdef LINEAR_DEPTH
float x = u * 2.0 - 1.0;
float y = v * 2.0 - 1.0;
vec4 vProjectedPos = vec4(x, y, 1.0, 1.0);
vec4 farViewspacePosition = invertedProjectionMatrix * vProjectedPos;
vec3 viewDirection = normalize(farViewspacePosition.xyz);
return viewDirection * z / viewDirection.z;
#else
float x = u * 2.0 - 1.0;
float y = v * 2.0 - 1.0;
vec4 vProjectedPos = vec4(x, y, z * 2.0 - 1.0, 1.0);
vec4 viewspacePosition = invertedProjectionMatrix * vProjectedPos;
return viewspacePosition.xyz / viewspacePosition.w;
#endif
}
vec3 viewSpaceNormalFromNeighbours(vec3 center, float fallbackDepth) {
vec2 right = (vUV + (vec2(1,0) * inverseDepthDimensions));
vec2 up = (vUV + (vec2(0,1) * inverseDepthDimensions));
float depthRight = texelFetch(depthSampler, ivec2(gl_FragCoord.xy + vec2(1, 0)), 0).r;
float depthUp = texelFetch(depthSampler, ivec2(gl_FragCoord.xy + vec2(0, 1)), 0).r;
depthRight = depthRight < 0.0 ? fallbackDepth : depthRight;
depthUp = depthUp < 0.0 ? fallbackDepth : depthUp;
vec3 pRight = viewSpacePositionFromDepth(depthRight, right.x, right.y);
vec3 pUp = viewSpacePositionFromDepth(depthUp, up.x, up.y);
return normalize(cross(normalize(pUp - center), normalize(pRight - center)));
}
float ambientOcclusionValue(vec3 viewSpaceFragment, vec3 viewSpaceNormal, vec2 screenUV) {
vec3 randSourceData = texture2D(noiseSampler, screenUV * noiseScale + noiseUvOffset).rgb;
vec3 rVec;
rVec.xy = randSourceData.rg * 2.0 - 1.0;
rVec.z = 0.0;
float occlusion = 0.0;
vec3 tangent = normalize(rVec - viewSpaceNormal * dot(rVec, viewSpaceNormal));
vec3 biTangent = cross(viewSpaceNormal, tangent);
mat3 tbn = mat3(tangent, biTangent, viewSpaceNormal);
float inverseRadiusSquared = 1.0 / (radius * radius);
for (int i = 0; i < sampleKernelSize; i++) {
vec3 sampleViewDirection = tbn * sampleKernel[i];
vec3 samplePosition = sampleViewDirection * radius * randSourceData.z + viewSpaceFragment;
vec4 offset = vec4(samplePosition, 1.0);
offset = projectionMatrix * offset;
offset.xy /= offset.w;
if (max(abs(offset.x), abs(offset.y)) >= 1.0) continue;
offset.xy = offset.xy * 0.5 + vec2(0.5);
float viewDepth = texture2D(depthSampler, offset.xy).r;
vec4 viewSpaceSample = vec4(viewSpacePositionFromDepth(viewDepth, offset.x, offset.y), 1.0);
float sampleDepth = viewSpaceSample.z;
vec3 sampleDelta = viewSpaceSample.xyz - viewSpaceFragment;
float sdd = dot(normalize(sampleDelta), sampleViewDirection);
if (sampleDepth + ssaoDepthBias < samplePosition.z) {
float weight = dot(sampleDelta, sampleDelta) * inverseRadiusSquared;
weight = clamp(weight, 0.0, 1.0);
weight = 1.0 - weight;
occlusion += sampleKernel[i].z * 2.0 * min(0.5, radius * radius / dot(sampleDelta, sampleDelta));
}
}
occlusion = 3.141592654 * occlusion / float(sampleKernelSize);
occlusion = clamp(occlusion, 0.0, 1.0);
return occlusion;
}
void main(void)
{
float pixelDepthValue = texelFetch(depthSampler, ivec2(gl_FragCoord.xy), 0).r;
if (pixelDepthValue < 0.0) {
gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
return;
}
vec3 viewSpacePosition = viewSpacePositionFromDepth(pixelDepthValue, vUV.x, vUV.y);
vec3 viewSpaceNormal = viewSpaceNormalFromNeighbours(viewSpacePosition, pixelDepthValue);
float ambientOcclusion = ambientOcclusionValue(viewSpacePosition, viewSpaceNormal, vUV);
gl_FragColor = vec4(ambientOcclusion, 0, 0, 1);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ao_computePixelShader = { name, shader };
//# sourceMappingURL=ao_compute.fragment.js.map